import React from 'react';

import BaseFilter from './BaseFilter';
import { getExperts } from '../../../actions/asyncActions';
import withFilterForm from '../../hocs/withFilterForm';

export default withFilterForm(() =>
    <BaseFilter
        action={getExperts}
        searchFieldName='text'
        searchFieldPlaceholder='Поиск'
        span={12} />
);
